import { Component, OnInit, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import * as Materialize from 'angular2-materialize/dist/index';
import { CognitoCallback, RegistrationUser } from '../cognito/cognito.service';

import { MaterializeDirective, MaterializeAction } from 'angular2-materialize';
import { useradminService } from './useradmin.service';
import { NavbarService } from '../navbar/navbar.service';

@Component({
  selector: 'app-useradmin',
  templateUrl: 'useradmin.component.html',
  styleUrls: ['useradmin.component.css'],
  providers: [useradminService]
})
export class UseradminComponent implements OnInit {
  public currentUseremail: string;
  public currentUserfirstname: string;
  public currentUserlastname: string;
  public useremail: string;
  public phonenumber: number;
  public userfirstname: string;
  public userlastname: string;
  public userid: number;
  public roleid: number;
  public errorMessage: string;
  registrationUser: RegistrationUser;

  planid: string;
  waiticon = '';

  disableAction = false;

  email = '';
  users = [];
  roles = [];
  loadingusers = true;
  edituserStatus: boolean;
  isAdmin = false;
  isUser = true;
  isEnabled = false;
  isITAR = false;
  // updatedInformation = false;
  updatedUserState = false;
  public dateFormat: string;

  itarEnabled = false;
  isRemovable = false;  // value will be depend on whether user has projects or not. (May be get user API will return this value.)

  crateAdminBool: boolean;
  modalNewUserAction = new EventEmitter<string | MaterializeAction>();
  modalEditUserAction = new EventEmitter<string | MaterializeAction>();
  modalRemoveUserAction = new EventEmitter<string | MaterializeAction>();
  constructor(private router: Router,
              public useradminservice: useradminService,
              public navService: NavbarService) { }

  ngOnInit() {
    this.navService.show('USER MANAGEMENT');
    this.navService.setNavID(3);
    this.registrationUser = new RegistrationUser();
    this.planid = localStorage.getItem('mr_planid');
    this.dateFormat = localStorage.getItem('mr_date_format_id');

    this.email = localStorage.getItem('mr_email');
    this.planid = localStorage.getItem('mr_planid');
    let admin = localStorage.getItem('isAdmin');

    this.loadingusers = true;

    this.getusers();
  }

  ngOnDestroy() {
    this.modalNewUserAction.emit({ action: 'modal', params: ['close'] });
    this.modalEditUserAction.emit({ action: 'modal', params: ['close'] });
    this.modalRemoveUserAction.emit({ action: 'modal', params: ['close'] });
  }

  getusers() {
    this.useradminservice.getUser()
      .subscribe(
      data => {
        console.log('Got users');
        let userdata = JSON.parse(data);
        // this.tempusers = userdata.users;
        this.users = userdata.users;
        this.roles = userdata.roles;
        this.loadingusers = false;
      },
      error => {

      });
  }


  validateEmail(Emailaddress) {

    let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

    if (!EMAIL_REGEXP.test(Emailaddress)) {
      return false;
    } else {
      return true;
    }
  }

  createNewUser() {

    if (!this.useremail || !this.userfirstname || !this.userfirstname) {
      console.error('User email, first name and last name are required fields');
      Materialize.toast('User email, first name and last name are required fields', 5000);
      return;
    }
    // Remove white space if any.

    this.useremail = this.useremail.trim();
    this.userfirstname = this.userfirstname.trim();
    this.userfirstname = this.userfirstname.trim();

    if (this.isUser == false && this.isAdmin == false) {
      Materialize.toast('Please select at least one role for user', 5000);
      return;
    }

    if (this.validateEmail(this.useremail) == false) {
      Materialize.toast('Invalid email address', 5000);
      return;
    }

    this.disableAction = true;

    this.useremail = this.useremail.toLowerCase();
    this.registrationUser.email = this.useremail;
    this.registrationUser.primary = 0;
    this.registrationUser.firstname = this.userfirstname;
    this.registrationUser.lastname = this.userlastname;

    this.roles = [];
    // if (this.isAdmin) {
    //   this.registrationUser.role = 1;
    // }

    //  if (this.isUser) {
    //   this.registrationUser.role = 1;
    // }



    this.roles = [];

    if (this.isUser) {
      this.roles.push(2);
    }
    if (this.isAdmin) {
      this.roles.push(1);
    }
    // this.registrationUser.password = "password";
    this.registrationUser.company = '';
    this.registrationUser.planid = '2';

    if (this.isITAR) {
      this.registrationUser.planid = '3';
    }

    if (!this.phonenumber) {
      // this.registrationUser.phone = ;
    } else {
      this.registrationUser.phone = this.phonenumber.toString();
    }


    this.waiticon = 'fa right fa-spinner fa-pulse';
    (<HTMLInputElement>document.getElementById('createNewUserBtn')).disabled = true;
    (<HTMLInputElement>document.getElementById('createNewUserCancelBtn')).disabled = true;

    this.useradminservice.addNewUser(this.registrationUser, this.roles)
      .subscribe(
      data => {

        try {
          let result = JSON.parse(data);
          if (result === true) {
            // Add user to MRC database
            this.useradminservice.addUserDatabase(this.registrationUser, this.roles).subscribe(
              data => {
                try {
                  let json = JSON.parse(data);
                  if (json == true) {
                    Materialize.toast('Successfully added new user.', 5000);
                    this.getusers();
                    console.log('successfully added new user to database');
                    this.waiticon = '';
                    (<HTMLInputElement>document.getElementById('createNewUserBtn')).disabled = false;
                    (<HTMLInputElement>document.getElementById('createNewUserCancelBtn')).disabled = false;
                    this.modalNewUserAction.emit({ action: 'modal', params: ['close'] });
                  } else {
                    Materialize.toast('Email is already registered, please try with another email Account.', 5000);
                    console.log('Error adding new user. : ' + result);
                    this.waiticon = '';
                    (<HTMLInputElement>document.getElementById('createNewUserBtn')).disabled = false;
                    (<HTMLInputElement>document.getElementById('createNewUserCancelBtn')).disabled = false;
                  }
                } catch (e) {
                  console.log('Exception Error message found  in adding new user ' + data);
                  Materialize.toast('Email is already registered, please try with another email Account.', 5000);
                  this.waiticon = '';
                  (<HTMLInputElement>document.getElementById('createNewUserBtn')).disabled = false;
                  (<HTMLInputElement>document.getElementById('createNewUserCancelBtn')).disabled = false;
                }

              },
              error => {
                console.log('Error adding new user' + error);
                Materialize.toast('Email is already registered, please try with another email Account.', 5000);
                this.waiticon = '';
                (<HTMLInputElement>document.getElementById('createNewUserBtn')).disabled = false;
                (<HTMLInputElement>document.getElementById('createNewUserCancelBtn')).disabled = false;
              });
          } else {
            Materialize.toast('Email is already registered, please try with another email Account.', 5000);
            console.log('Error adding new user ' + result);
            this.waiticon = '';
            (<HTMLInputElement>document.getElementById('createNewUserBtn')).disabled = false;
            (<HTMLInputElement>document.getElementById('createNewUserCancelBtn')).disabled = false;
          }
        }
        catch (e) {
          console.log('Exception Error message found  in adding new usewr  ' + data);
          Materialize.toast('Email is already registered, please try with another email Account.', 5000);
          this.waiticon = '';
          (<HTMLInputElement>document.getElementById('createNewUserBtn')).disabled = false;
          (<HTMLInputElement>document.getElementById('createNewUserCancelBtn')).disabled = false;
        }
      },
      error => {
        this.modalNewUserAction.emit({ action: 'modal', params: ['close'] });
        this.waiticon = '';
        (<HTMLInputElement>document.getElementById('createNewUserBtn')).disabled = false;
        (<HTMLInputElement>document.getElementById('createNewUserCancelBtn')).disabled = false;
        console.log('Error adding new user. ' + error);
        Materialize.toast('Error adding new user.', 5000);
      });
  }

  cognitoCallback(message: string, result: any) {

    if (message != null) { // error
      // this.errorMessage = message;
      // this.backenderror = true;
      console.log('result: ' + this.errorMessage);
      // this.buttonicon = "fa right fa-user-plus";
    } else { // success
      console.log('result: ' + 'success');

      /*this.useradminservice.addNewUser(this.registrationUser)
         .subscribe(
           data  => {
              console.log("user added to tenant Id : ", this.registrationUser.email);
              // this.router.navigate(['/registerconfirm', this.registrationUser.email]);
           },
           error => {
            //  this.buttonicon = "fa right fa-user-plus";
            //  this.backenderror = true;
            //  this.errorMessage = <any>error;
            //  console.error('register() error:', this.errorMessage);
           } );*/
    }
  }


  storeUserInfo(user) {

    this.useremail = user.email;
    this.userfirstname = user.firstname;
    this.userlastname = user.lastname;

    let userarrSize = user.roles.length - 1;

    this.isAdmin = false;
    this.isUser = false;

    for (let i = 0; i <= userarrSize; i++) {
      if (user.roles[i] == 1) {
        this.isAdmin = true;
      }

      if (user.roles[i] == 2) {
        this.isUser = true;
      }
    }

    this.phonenumber = user.phone;

    if (user.enabled) {
      this.isEnabled = true;
    } else {
      this.isEnabled = false;
    }
    if (user.itaraccess) {
      this.itarEnabled = true;
    } else {
      this.itarEnabled = false;
    }
    this.userid = user.id;
    this.roleid = user.roleid;

    if (user.projectcount <= 0) {
      this.isRemovable = true;
    } else {
      this.isRemovable = false;
    }
  }

  changeAdminRole() {
    this.isAdmin = !this.isAdmin;
  }

  changeUserRole() {
    this.isUser = !this.isUser;
  }

  changeITARRole() {
    this.isITAR = !this.isITAR;
  }

  cleanData() {
    this.useremail = '';
    this.isAdmin = false;
    this.isUser = true;
    this.itarEnabled = false;
    this.userfirstname = '';
    this.userlastname = '';
    this.isEnabled = false;
    this.phonenumber = null;
    this.userid = 0;
    this.roleid = 0;
    this.isRemovable = false;
  }

  updateUser() {

  }

  openCreateNewUserModal() {

    this.cleanData();
    this.waiticon = '';
    this.modalNewUserAction.emit({ action: 'modal', params: ['open'] });
  }

  cancalCreateNewUser() {
    this.waiticon = '';
    this.cleanData();
  }

  cancalEditUserInfo() {
    this.waiticon = '';
    this.cleanData();
  }

  openEditUserModal(user) {
    this.storeUserInfo(user);
    this.waiticon = '';

    // userstateCheckbox
    // userCheckBox
    // adminCheckBox
    if (this.email === this.useremail) {
      (<HTMLInputElement>document.getElementById('userstateCheckbox')).disabled = true;
      (<HTMLInputElement>document.getElementById('editrole1')).disabled = true;

      //  (<HTMLInputElement>document.getElementById("editrole3")).disabled = true;
    } else {
      (<HTMLInputElement>document.getElementById('userstateCheckbox')).disabled = false;
      (<HTMLInputElement>document.getElementById('editrole1')).disabled = false;
      // (<HTMLInputElement>document.getElementById("editrole3")).disabled = false;
    }


    this.modalEditUserAction.emit({ action: 'modal', params: ['open'] });
  }

  updateUserInformation() {

    // Must select one role for user.
    if (this.isUser == false && this.isAdmin == false) {
      Materialize.toast('Please select one role for user.', 5000);
      return;
    }

    this.waiticon = 'fa right fa-spinner fa-pulse';
    (<HTMLInputElement>document.getElementById('updateUserInfoBtn')).disabled = true;
    (<HTMLInputElement>document.getElementById('updateUserInfoCancelBtn')).disabled = true;

    this.disableAction = true;

    //   this.updatedInformation = false;
    //     updatedInformation = false;
    // updatedUserState= false;

    this.roles = [];

    if (this.isUser) {
      this.roles.push(2);
    }
    if (this.isAdmin) {
      this.roles.push(1);
    }
    // Not checking responce for update user, we will add code for it latter.
    this.addRoleToUserwith(this.userid, this.roles);
    this.useradminservice.updateUserInformation(this.userid, this.userfirstname, this.userlastname, this.phonenumber, this.isEnabled).subscribe(

      data => {
        try {
          let json = JSON.parse(data);
          if (json == true) {

            if (this.updatedUserState) {
              this.useradminservice.changesActivityStateOfUserCognito(this.useremail, this.isEnabled).subscribe(
                data => {
                  console.log(' data : ', data);
                },
                error => {
                  console.log('Error updating user information');
                });
            }

            this.updateLocalUserInformation(this.useremail);
            console.log('User information is updated');
            Materialize.toast('User information is updated.', 5000);
          } else {
            Materialize.toast('Error updating user information.', 5000);
            console.log('Error' + json);

          }
        } catch (e) {
          Materialize.toast('Error updating user information.', 5000);
          // the variable json is out of scope here
          // console.log('Error' + json);
          console.log('Error');
        }
        finally {
          this.waiticon = '';
          (<HTMLInputElement>document.getElementById('updateUserInfoBtn')).disabled = false;
          (<HTMLInputElement>document.getElementById('updateUserInfoCancelBtn')).disabled = false;
          this.modalEditUserAction.emit({ action: 'modal', params: ['close'] });
        }
      },
      error => {
        this.waiticon = '';
        (<HTMLInputElement>document.getElementById('updateUserInfoBtn')).disabled = false;
        (<HTMLInputElement>document.getElementById('updateUserInfoCancelBtn')).disabled = false;
        console.log('Error updating user information ' + error);
        Materialize.toast('Error updating user information.', 5000);
        this.modalEditUserAction.emit({ action: 'modal', params: ['close'] });
      });
  }

  openRemoveUserModal(user) {
    this.storeUserInfo(user);
    this.modalRemoveUserAction.emit({ action: 'modal', params: ['open'] });
  }

  changeActivityState() {
    this.isEnabled = !this.isEnabled;
    this.updatedUserState = true;
  }

  changeState() {
    this.useradminservice.changesActivityStateOfUser(this.userid, false).subscribe(
      data => {
        console.log(' change state Done. ');
        this.useradminservice.changesActivityStateOfUserCognito(this.useremail, false).subscribe(
          data => {
            console.log(' change state Done. ');
            this.getusers();
          },
          error => {
            console.log('result: ' + error);
            Materialize.toast('result: ' + error, 5000);
          });
      },
      error => {
        console.log('result: ' + error);
        Materialize.toast('result: ' + error, 5000);
      });
  }

  confirmUserDelete() {
    console.log('USEREMAIL TO DELETE:', this.useremail);
    console.log('this.userid:', this.userid);
    this.waiticon = 'fa right fa-spinner fa-pulse';
    (<HTMLInputElement>document.getElementById('removeBtn')).disabled = true;
    (<HTMLInputElement>document.getElementById('cancelUserDeleteBtn')).disabled = true;

    this.useradminservice.deleteUserLoginRecord(this.useremail).subscribe(
      data => {
        // Call the user update API to disable the user in the MR2 database
        this.useradminservice.deleteUserFromDatabase(this.userid).subscribe(
          data => {
            console.log('User deleted');
            Materialize.toast('USER DELETED SUCCESSFULLY.', 1000);
            this.getusers();
            this.waiticon = '';
            this.modalRemoveUserAction.emit({ action: 'modal', params: ['close'] });
            (<HTMLInputElement>document.getElementById('removeBtn')).disabled = false;
            (<HTMLInputElement>document.getElementById('cancelUserDeleteBtn')).disabled = false;
          },
          error => {
            console.log('Error deleting user:' + error);
            Materialize.toast('Error deleting user', 5000);
            this.waiticon = '';
            this.modalRemoveUserAction.emit({ action: 'modal', params: ['close'] });
            (<HTMLInputElement>document.getElementById('removeBtn')).disabled = false;
            (<HTMLInputElement>document.getElementById('cancelUserDeleteBtn')).disabled = false;
          });
      },
      error => {
        this.errorMessage = <any>error;
        this.waiticon = '';
        (<HTMLInputElement>document.getElementById('removeBtn')).disabled = false;
        (<HTMLInputElement>document.getElementById('cancelUserDeleteBtn')).disabled = false;
        console.error('confirmUserDelete() error:', this.errorMessage);
        Materialize.toast('Error deleting user: ' + this.errorMessage, 5000);
      });
  }

  checkEmptyField() {

  }

  addRoleToUser() {
    this.useradminservice.addRoleToUser(this.userid, 2).subscribe(
      data => {
        this.getusers();
        this.waiticon = '';
      },
      error => {
        this.errorMessage = <any>error;
        console.error('addRoletoUser() error:', this.errorMessage);
      });
  }


  deleteUserRolewith(userId, role) {

    this.useradminservice.deleteUserRole(userId, role).subscribe(
      data => {
        // if true
        this.deactivateUser();
        console.log('deleteUserRolewith');
      },
      error => {
        this.errorMessage = <any>error;
        console.error('deleteUserRole() error:', this.errorMessage);
      });
  }

  addRoleToUserwith(userId, role) {
    this.useradminservice.addRoleToUser(userId, role).subscribe(
      data => {
        console.log('addRoleToUserwith');
      },
      error => {
        this.errorMessage = <any>error;
        console.error('addRoletoUser() error:', this.errorMessage);
      });
  }

  // Only for deactivating the user from model pop up.
  deactivateUser() {
    this.waiticon = 'fa right fa-spinner fa-pulse';
    (<HTMLInputElement>document.getElementById('deactivateUserBtn')).disabled = true;
    (<HTMLInputElement>document.getElementById('cancelUserDeleteBtn')).disabled = true;

    this.useradminservice.changesActivityStateOfUser(this.userid, 0).subscribe(
      data => {
        this.useradminservice.changesActivityStateOfUserCognito(this.useremail, 0).subscribe(
          data => {
            console.log(' change state Done. ');
            this.getusers();
            this.waiticon = '';
            (<HTMLInputElement>document.getElementById('deactivateUserBtn')).disabled = false;
            (<HTMLInputElement>document.getElementById('cancelUserDeleteBtn')).disabled = false;
            this.modalRemoveUserAction.emit({ action: 'modal', params: ['close'] });
          },
          error => {
            console.log('result: ' + error);
            Materialize.toast('result: ' + error, 5000);
            this.waiticon = '';
            (<HTMLInputElement>document.getElementById('deactivateUserBtn')).disabled = false;
            (<HTMLInputElement>document.getElementById('cancelUserDeleteBtn')).disabled = false;
            this.modalRemoveUserAction.emit({ action: 'modal', params: ['close'] });
          });

      },
      error => {
        console.log('result: ' + error);
        Materialize.toast('result: ' + error, 5000);
        this.waiticon = '';
        (<HTMLInputElement>document.getElementById('deactivateUserBtn')).disabled = false;
        (<HTMLInputElement>document.getElementById('cancelUserDeleteBtn')).disabled = false;
      });
  }
  //  It cancel Delete a user model , need to clean data "userfull name" after cancelation.
  cancelUserDelete() {
    this.cleanData();
  }

  updateUserRole() {
    // this.useradminservice.addroletouser( this.userid , this.roleid );
  }

  updateLocalUserInformation(email) {
    for (let i = 0; i <= this.users.length - 1; i++) {
      if (this.users[i].email == email) {
        this.users[i].phone = this.phonenumber;
        this.users[i].lastname = this.userlastname;
        this.users[i].firstname = this.userfirstname;
        this.users[i].roles = this.roles;
        this.users[i].enabled = this.isEnabled;
        break; // Stop this loop, we found it!
      }
    }
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/useradmin/useradmin.component.ts